export enum TitleStyleDto {
    None = 0,
    Title = 1,
    Subtitle = 2,
    SubtitleEmphasis = 3,
}
